var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import GlobalConfig from '../global_configs';
import { consoleLoganIfSwitchIsOn, getLoganUnionId } from './common';
var PackageConfig = require('../../package.json');
var SDKVersion = PackageConfig.version;
var logMetricCountQuota = 1; // 日志存储过程统计只有一次上报额度（为避免与owl循环引用引发死循环）
var sdkErrorCountQuota = 1; // SDK JS异常的统计只有一次上报额度
var OwlConfig = {
    project: 'logan-web',
    devMode: false,
    metric: {
        sample: 1
    },
    resource: {
        sampleApi: 1,
        delay: 100
    }
};
var owlInstance;
function errorStringify(e) {
    if (e instanceof Error) {
        return JSON.stringify({
            errorMsg: e.message,
            errorStack: e.stack
        });
    }
    else {
        return JSON.stringify({
            error: typeof e === 'object' ? JSON.stringify(e) : e
        });
    }
}
var getCurrentOwlProject = function () {
    var _a;
    return (_a = window.Owl) === null || _a === void 0 ? void 0 : _a.cfgManager.get('project');
};
var getCurrentOwlUnionId = function () {
    var _a;
    return (_a = window.Owl) === null || _a === void 0 ? void 0 : _a.cfgManager.getExtension('unionId');
};
// 上报Logan Web SDK的CDN加载耗时
var reportSDKLoadTiming = function (sdkVersion, urls, devMode) {
    var _a, _b;
    if ((_a = window.Owl) === null || _a === void 0 ? void 0 : _a.SDKMetrics) {
        window.Owl.SDKMetrics({
            project: 'logan-web',
            userProject: getCurrentOwlProject(),
            version: sdkVersion,
            url: urls,
            tags: {
                protocol: (_b = window.location) === null || _b === void 0 ? void 0 : _b.protocol
            },
            pv: {
                auto: false
            },
            resource: {
                auto: true,
                sample: 0.01
            },
            devMode: devMode
        });
    }
};
var _getOwlAndCb = function (cb) {
    var owlConfig = __assign(__assign({}, OwlConfig), { devMode: GlobalConfig.get('devMode') });
    if (owlInstance !== undefined) {
        cb(owlInstance);
    }
    else if (window.Owl) {
        owlInstance = new window.Owl.OWL(owlConfig);
        cb(owlInstance);
    }
    else {
        import(/* webpackChunkName: "owl" */ '@dp/owl').then(function (moduleOb) {
            // 为异步ES模块增加衬垫，防止类似add-module-exports的插件影响ES模块的export，
            // 同时在webpack4打包的项目要加载异步CommonJS模块时也需要，因为其会对模块增加外层包裹{default: xxx, __esModule: true}
            return moduleOb.default || moduleOb;
        }).then(function (owl) {
            owlInstance = new owl.OWL(owlConfig);
            cb(owlInstance);
        }).catch(function (e) {
            consoleLoganIfSwitchIsOn('import dynamic owl error:' + e.stack);
        });
    }
};
var _owlMetric = function (owl, tags, metricName, metricValue) {
    var metricManager = window.Owl.MetricManager(owl.cfgManager);
    metricManager.setTags(tags);
    metricManager.setMetric(metricName, metricValue);
    metricManager.report();
};
var _owlAddError = function (owl, errCategory, errMsg, err, errLevel) {
    owl.addError({
        name: '2.x版本异常：' + errMsg,
        msg: errorStringify(err)
    }, {
        level: errLevel || 'error',
        category: errCategory,
        tags: {
            projectName: getCurrentOwlProject() || 'unknown',
            sdkVersion: SDKVersion,
            loganUnionId: getLoganUnionId()
        }
    });
};
// 日志存储过程打点
var asyncAddMetricInSaveProcess = function (errMsg, e) {
    if (logMetricCountQuota > 0) {
        logMetricCountQuota--;
        var baseTags_1 = {
            'sdkVersion': SDKVersion,
            'projectName': getCurrentOwlProject() || 'unknown'
        };
        var finalTags_1 = (function () {
            if (!errMsg) {
                return __assign({ isSucc: true }, baseTags_1);
            }
            else {
                return __assign({ isSucc: false, failType: errMsg }, baseTags_1);
            }
        })();
        _getOwlAndCb(function (owl) {
            _owlMetric(owl, finalTags_1, 'SaveLogResult', 0);
            // 如果有异常，还需要上报异常
            if (errMsg) {
                _owlAddError(owl, 'customError', errMsg, e);
            }
        });
    }
};
// 日志上报过程打点
var asyncAddMetricInReportProcess = function (reportInfo, errMsg, e) {
    var baseTags = {
        'project': getCurrentOwlProject() || 'unknown',
        'uploadSource': reportInfo.uploadSource,
        'webSource': reportInfo.webSource,
        'SDKversion': SDKVersion
    };
    var finalTags = (function () {
        if (!errMsg) {
            return __assign({ isSucc: true }, baseTags);
        }
        else {
            return __assign({ isSucc: false, failType: errMsg }, baseTags);
        }
    })();
    _getOwlAndCb(function (owl) {
        _owlMetric(owl, finalTags, 'LoganWebReport', reportInfo.duringTime);
        // 如果有异常，还需要上报异常
        if (errMsg) {
            _owlAddError(owl, 'customError', errMsg, e);
        }
    });
};
// 上报SDK内部发生的JS异常
var asyncAddSDKError = function (errMsg, e) {
    if (sdkErrorCountQuota > 0) {
        sdkErrorCountQuota--;
        _getOwlAndCb(function (owl) {
            _owlAddError(owl, 'jsError', errMsg, e);
        });
    }
};
export default {
    asyncAddSDKError: asyncAddSDKError,
    asyncAddMetricInSaveProcess: asyncAddMetricInSaveProcess,
    asyncAddMetricInReportProcess: asyncAddMetricInReportProcess,
    getCurrentOwlProject: getCurrentOwlProject,
    getCurrentOwlUnionId: getCurrentOwlUnionId,
    reportSDKLoadTiming: reportSDKLoadTiming
};
